exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.private_area_tabs[data-v-2728aa97] {\n  padding: 12px;\n}\n", ""]);

// exports
